package com.shreyasjoshi.components

import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*

@Composable
fun ResumeModal(
    isOpen: Boolean,
    isDarkMode: Boolean,
    onClose: () -> Unit
) {
    if (!isOpen) return

    Div(
        attrs = {
            classNames(
                "resume-overlay", "fixed", "inset-0", "z-50", "flex", "items-center", "justify-center", "p-4",
                "bg-black/80", "backdrop-blur-sm"
            )
            onClick { onClose() }
        }
    ) {
        Div(
            attrs = {
                classNames(
                    "resume-dialog", "w-full", "max-w-4xl", "h-[calc(100vh-2rem)]", "max-h-[calc(100vh-2rem)]",
                    "rounded-sm", "border", "flex", "flex-col",
                    "overflow-hidden", "shadow-2xl",
                    if (isDarkMode) "bg-[#0a0a0a] border-white/10 text-white"
                    else "bg-white border-slate-200 text-slate-900"
                )
                // Stop click propagation inside the modal container
                onClick { e -> e.stopPropagation() }
            }
        ) {
            // Modal Header
            Div(
                attrs = {
                    classNames(
                        "resume-header", "flex", "items-center", "justify-between", "px-6", "py-4", "border-b",
                        if (isDarkMode) "border-white/10" else "border-slate-200"
                    )
                }
            ) {
                Div(attrs = { classNames("resume-title", "flex", "items-center", "gap-3") }) {
                    Div(
                        attrs = {
                            classNames(
                                "w-8", "h-8", "rounded-sm", "bg-[#189AD3]/10", "text-[#71C7EC]",
                                "border", "border-[#189AD3]/30", "flex", "items-center", "justify-center",
                                "font-mono", "font-bold", "text-xs"
                            )
                        }
                    ) {
                        Text("PDF")
                    }
                    Div {
                        H3(attrs = { classNames("font-bold", "text-sm") }) {
                            Text("Shreyas Joshi — Resume")
                        }
                        P(attrs = { classNames("text-xs", "font-mono", "text-[#189AD3]") }) {
                            Text("Shreyas_Joshi_Resume.pdf")
                        }
                    }
                }

                // Modal Actions (Download, External Tab, Close)
                Div(attrs = { classNames("resume-actions", "flex", "items-center", "gap-2") }) {
                    A(
                        href = "/Shreyas_Joshi_Resume.pdf",
                        attrs = {
                            classNames(
                                "px-3.5", "py-1.5", "rounded-sm", "text-xs", "font-mono", "font-semibold",
                                "bg-[#189AD3]", "hover:bg-[#107DAC]", "text-white", "transition-colors"
                            )
                            attr("download", "Shreyas_Joshi_Resume.pdf")
                        }
                    ) {
                        Text("DOWNLOAD")
                    }

                    A(
                        href = "/Shreyas_Joshi_Resume.pdf",
                        attrs = {
                            classNames(
                                "px-3", "py-1.5", "rounded-sm", "border", "text-xs", "font-mono", "transition-colors",
                                if (isDarkMode) "border-white/10 text-white/70 hover:text-white bg-white/5"
                                else "border-slate-200 text-slate-700 hover:text-slate-900 bg-slate-50"
                            )
                            attr("target", "_blank")
                            title("Open in new browser tab")
                        }
                    ) {
                        Text("↗ Open")
                    }

                    Button(
                        attrs = {
                            classNames(
                                "px-3", "py-1.5", "rounded-sm", "border", "text-xs", "font-mono", "transition-colors",
                                if (isDarkMode) "border-white/10 text-white/50 hover:text-white bg-white/5"
                                else "border-slate-200 text-slate-500 hover:text-black"
                            )
                            attr("aria-label", "Close resume preview")
                            onClick { onClose() }
                        }
                    ) {
                        Text("✕")
                    }
                }
            }

            // PDF Embed / Preview
            Div(
                attrs = {
                    classNames(
                        "flex-1", "min-h-0", "flex", "items-stretch", "justify-center", "relative",
                        if (isDarkMode) "bg-[#050505]" else "bg-slate-100"
                    )
                }
            ) {
                Iframe(
                    attrs = {
                        classNames("w-full", "h-full", "border-0")
                        attr("src", "/Shreyas_Joshi_Resume.pdf#toolbar=0")
                        title("Resume Document Preview")
                    }
                )
            }
        }
    }
}
